<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="3600"
          :reset="true"
          :expand-adv="true"
          :show-simple="false"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="primary"
              @click="cancelAccrueHandler"
            >{{ this.$t('CargoMsg.Cargo_CancelAccrue') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="25000623"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="25000624"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toAdvancedQuery"
          />
        </div>
      </div>
    </div>

    <!--    查看关联业务-->
    <show-history-job-dialog
      v-if="showJobDialog.visible"
      ref="showJobDialog"
      :visible.sync="showJobDialog.visible"
      :jobs="showJobDialog.jobs"
      :rule-configs="showJobDialog.ruleConfigs"
      @close="showJobDialog.visible = false"
    />

    <accrue-select-dialog
      v-if="accrueSelectDialog.visible"
      ref="accrueSelectDialog"
      :visible.sync="accrueSelectDialog.visible"
    />
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AccrueSelectDialog from '@/views/cargo/v0/Performance/tabPane/accrueSelectDialog.vue'
import { advancedQueryFunc, cancelProvisionFunc } from '@/api/ruleConfig/provisionReport'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage } from '@/utils/commonUtil'
import showHistoryJobDialog from '@/views/cargo/v0/Performance/tabPane/showHistoryJobDialog.vue'
import { advancedQuery } from '@/api/ruleConfig/ruleConfigAi'

export default {
  name: 'ProvisionHistory',
  components: {
    showHistoryJobDialog,
    AccrueSelectDialog,
    searchItem
  },
  data() {
    return {
      URL,
      isAdvancedQuery: true, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      accrueSelectDialog: {
        visible: false
      },
      showJobDialog: {
        visible: false,
        jobs: [],
        ruleConfigs: []
      },
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProvisionBatchNumber'),
          colId: 'batchNo',
          field: 'batchNo',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProvisionPerson'),
          colId: 'provisionUserId',
          field: 'provisionUserId',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProvisionTime'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProvisionRole'),
          colId: 'commissionRole',
          field: 'commissionRole',
          width: 150,
          cellRenderer: (params) => {
            return CommonState.getNameByCode(SystemConstants.COMMISSION_ROLE_LIST, params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LockLimit'),
          colId: 'lockCharge',
          field: 'lockCharge',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.IsBookedLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ViewProvisionDetails'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          cellRenderer: params => {
            if (params.data.provisionReportVOS) {
              const onViewDetailedBusiness = this.documentManage.getPath('onViewDetailedBusiness')
              return `<button><div onclick="${onViewDetailedBusiness}('${params.data.batchNo}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div></button>`
            } else {
              return ''
            }
          }
        }
      ],
      documentManage: new DocumentManage(),
      ruleConfigs: [],
      rowData: []
    }
  },
  computed: {},
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toAdvancedQuery()
    }
  },
  beforeMount() {
    setTimeout(() => {
      this.init()
      this.toAdvancedQuery()
    }, 0)
    const context = this
    this.documentManage.set('onViewDetailedBusiness', function(value) {
      context.onViewDetailedBusiness(value)
    })
  },
  methods: {
    async init() {
      this.ruleConfigs = []
      const from = {}
      from.branchId = this.$store.getters.currentOfficeId
      advancedQuery(from).then(res => {
        this.ruleConfigs = res.data.list
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filter.conditions = [...data]
        this.filter.pageNum = 1
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      advancedQueryFunc(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onViewDetailedBusiness(batchNo) {
      if (batchNo) {
        const rows = this.rowData.filter(p => p.batchNo === batchNo)
        if (rows && rows.length > 0) {
          this.showJobDialog.jobs = rows[0].provisionReportVOS
          this.showJobDialog.ruleConfigs = this.ruleConfigs
          this.showJobDialog.visible = true
        }
      }
    },
    // 取消计提
    cancelAccrueHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmCancelProvision'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading4Cxt()
        const data = {
          keys: Array.from(rows, p => p.batchNo)
        }
        cancelProvisionFunc(data).then(res => {
          this.toAdvancedQuery()
          this.$message.success(this.$t('CargoMsg.Cargo_CancelSuccessfully'))
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      })
    }
  }
}
</script>
